import { createRoute } from '@tanstack/react-router';
import { layoutRoute } from '@/router/root-routes.tsx';
import { installations, type InstallColor } from '@/app/pages/installations.ts';
import { AppBreadcrumbs } from '@/components/app/app-breadcrumbs.tsx';
import { usePageProps } from '@/hooks/use-page-props.ts';
import { useRipple } from '@/hooks/use-ripple.ts';

export const viewInstallationRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/view-installation/$id',
  component: ViewInstallation,
});

function ViewInstallation() {
  const params = viewInstallationRoute.useParams();
  const installation = installations.find((i) => i.id == params.id);
  usePageProps({ title: installation?.name });
  const { ref } = useRipple();
  if (!installation) {
    return <div>Installation not found</div>;
  }
  const installType = installation.type === 'residential' ? 'Residential Installations' : 'Hospitality Installations';
  const installUrl = installation.type === 'residential' ? '/installations-residential' : '/installations-hospitality';
  return (
    <div className="max-w-8xl mx-auto px-4">
      <img src={installation.src} alt={installation.name} className="w-full h-auto" />
      <AppBreadcrumbs
        items={[
          { text: 'Home', href: '/' },
          { text: installType, href: installUrl },
        ]}
      />
      <h2 className="uppercase text-center">{installation.name}</h2>
      <div ref={ref} className="flex flex-wrap justify-center gap-4 mt-4">
        {installation.colors?.map((color) => <ColorBox key={color.src} color={color} />)}
      </div>
    </div>
  );
}

const ColorBox = ({ color }: { color: InstallColor }) => {
  const id = color.to.split('/').pop();
  return (
    <div className="ripple max-w-96">
      {/*<Link to={color.to} viewTransition={true}>*/}
      <img src={color.src} alt={color.src} className="w-full h-auto mb-1" />
      <h4 className="text-muted-foreground">ID: {id}</h4>
      {/*</Link>*/}
    </div>
  );
};
